export default __webpack_public_path__ + "static/media/trade-platforms.15a39e51.png";